export default __webpack_public_path__ + "static/media/logout-icon.0ce7e071.svg";